(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/components/bankid-start.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/components/bankid-start.js');

'use strict';

const Button = svs.ui.ReactButton;
const Bank = svs.ui.ReactBank;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$playerLoginReact = svs.playerLoginReact.constants,
  route = _svs$playerLoginReact.route,
  loginType = _svs$playerLoginReact.loginType;
const saveRefForGUITest = svs.playerLoginReact.sharedComponents.sharedUtils.saveRefForGUITest;
const getBankIdAutoStartTokenAsync = svs.playerLoginReact.bankid.BankidService.getBankIdAutoStartTokenAsync;
const _svs$playerLoginReact2 = svs.playerLoginReact.sharedComponents,
  useUrlHelper = _svs$playerLoginReact2.useUrlHelper,
  SelectEidMenu = _svs$playerLoginReact2.SelectEidMenu;
const setPlayerLoginType = svs.playerLoginReact.store.playerloginreactactions.setPlayerLoginType;

const BankIdStart = _ref => {
  let isLogin = _ref.isLogin,
    setPreFetchedAst = _ref.setPreFetchedAst;
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const isIosNotNative = svs.core.detect.os.iOS() && !isNativeApp;
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const _useUrlHelper = useUrlHelper(),
    navigateToCancelUrl = _useUrlHelper.navigateToCancelUrl,
    getBankIdAppUrl = _useUrlHelper.getBankIdAppUrl;
  const onBankIdThisDeviceClick = async () => {
    if (isIosNotNative) {
      if (isLogin) {
        window.history.replaceState({}, '', baseUrl + route.LOGIN_BANKID_POLL_APP_ROUTE);
      } else {
        window.history.replaceState({}, '', baseUrl + route.REGISTRATE_BANKID_POLL_APP_ROUTE);
      }

      const _await$getBankIdAutoS = await getBankIdAutoStartTokenAsync(),
        ast = _await$getBankIdAutoS.autoStartToken;

      saveRefForGUITest(ast);

      const appUrl = getBankIdAppUrl(ast);

      setPreFetchedAst(ast);

      svs.utils.url.navigate(appUrl);
    } else if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_APP_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_APP_ROUTE);
    }
  };

  React.useLayoutEffect(() => {
    dispatch(setPlayerLoginType(loginType.BANKID));
    if (!isStandardMobile) {
      if (isLogin) {
        history.push(route.LOGIN_BANKID_POLL_QR_ROUTE);
      } else {
        history.push(route.REGISTRATE_BANKID_POLL_QR_ROUTE);
      }
    }
  }, [history, isLogin]);
  return React.createElement(React.Fragment, null, isStandardMobile && React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement(SelectEidMenu, {
    isBankId: true,
    isLogin: isLogin
  }), React.createElement(Button, {
    block: true,
    iconPosition: "left",
    inverted: true,
    onClick: onBankIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left animate animate-show animate-time-short",
    name: "bankid-neg",
    size: 24
  }), React.createElement("span", {
    className: "animate animate-show animate-time-short"
  }, "Starta BankID"))), React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: navigateToCancelUrl,
    size: 300,
    transparent: true
  }, "Avbryt"))), !isStandardMobile && null);
};
svs.playerLoginReact.bankid.components.BankIdStart = BankIdStart;

 })(window);